export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/v4/like/icon-like-off-light-753107a62f45341aac8510213d4bbe6a.svg";